export const getData = (t) => {
  return {
    label: t('homeHuddInMedia.label'),
    title: t('homeHuddInMedia.title'),
  };
};

export const featuredMediaArticle = {
  id: 'nrk',
  date: '15.02.2025',
  source: 'NRK',
  image: '/hudd-nrk.webp',
  imageAlt: 'Hudd app on a phone showing a map of Norway',
  title: 'Den norske appen Hudd vil ta over for Facebook i Noreg',
  text: 'Over 45 000 nordmenn har sidan november lasta ned Hudd, eit nytt norsk sosialt medium. Håpet til utviklarane er å ta over brukarane til Facebook.',
  href: 'https://www.nrk.no/vestland/den-norske-appen-hudd-vil-ta-over-for-facebook-i-noreg-1.17253677',
};

export const sideMediaArticles = [
  {
    id: 'dinbedrift',
    date: '25.02.2025',
    source: 'DinBedrift',
    image: '/eigil-dinbedrift.jpg',
    imageAlt: 'Article about Hudd on DinBedrift',
    title: 'Ekte Digitalt Fellesskap - Også For SMB?',
    text: 'Med sin kombinasjon av visjon, fokus og praktisk nytte har Hudd truffet en nerve i et Norge som lengter etter noe ekte.',
    href: 'https://dinbedrift.no/ekte-digitalt-fellesskap-ogsa-for-smb/',
  },
  {
    id: 'tv2',
    date: '05.04.2025',
    source: 'TV2',
    image: '/tv2-article.webp',
    imageAlt: 'Article about Hudd on TV2',
    title: 'Tok av etter inntoget av Trump og Musk',
    text: 'Digitaliseringsminister Karianne Tung registrerer seg som bruker nummer 100.000 på den norske plattformen Hudd.',
    href: 'https://www.tv2.no/nyheter/innenriks/tok-av-etter-inntoget-av-trump-og-musk/17604386',
  },
  {
    id: 'neighbors',
    date: '01.02.2026',
    source: 'DinBedrift',
    image: '/new/hudd-in-media/hudd-digital.png',
    imageAlt: 'Meet your neighbors on Hudd',
    title: 'Meet Your Neighbors, Not Just Your Street',
    text: 'Over 45 000 nordmenn har sidan november lasta ned Hudd, eit nytt norsk sosialt medium.',
    href: 'https://dinbedrift.no/ekte-digitalt-fellesskap-ogsa-for-smb/',
  },
];
